import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Offer } from '../models/offer';
import { Paginated } from '../models/papginated';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class OfferLikeService {
    constructor(private readonly apiService: ApiService) {}

    like(offerId: number): Observable<{ success: boolean; liked: boolean }> {
        return this.apiService.post<{ success: boolean; liked: boolean }>(`/api/offers/${offerId}/like`, {});
    }

    unlike(offerId: number): Observable<{ success: boolean; liked: boolean }> {
        return this.apiService
            .delete(`/api/offers/${offerId}/like`)
            .pipe(map((res: { success?: boolean; liked?: boolean }) => ({ success: true, liked: res?.liked ?? false })));
    }

    isLiked(offerId: number): Observable<boolean> {
        return this.apiService.get<{ liked: boolean }>(`/api/offers/${offerId}/liked`, true).pipe(map((res) => !!res.liked));
    }

    getLiked(page: number = 1, perPage: number = 15): Observable<Paginated<Offer>> {
        const qs = ApiService.objectToQueryString({ page, perPage });
        return this.apiService.get<{ items: Offer[]; total: number; page: number; perPage: number }>(`/api/offers/liked?${qs}`).pipe(
            map((res) => ({
                items: (res.items ?? []).map((offer) => new Offer(offer)),
                total: res.total,
                page: res.page,
                perPage: res.perPage,
            })),
        );
    }
}
